import { FC } from "react"

import styles from "../styles/Card.module.scss"

interface CompanyCardProps {
  item: any
  theme?: string
  onClick: (ev: any) => void
}

const CompanyCard: FC<CompanyCardProps> = ({
  item, theme = "light", onClick
}) => {
  return (
    <>
      <div className={styles.card + (theme == "dark" ? " " + styles.dark : "")} onClick={onClick}>
        {item.distance != 0 ? <div className={styles.card_distance}>{item.distance.toFixed(0)} км</div> : <></>}
        <div className={styles.card_title}>{item.title}</div>
        <div className={styles.card_address}>{item.address}</div>
        <div className={styles.card_arrow}><i className="fas fa-chevron-right"></i></div>
      </div>
    </>
  )
}

export default CompanyCard